import { useCallback, useLayoutEffect } from "react";

import { Language } from "../../assets/languages/langs";
import { useTypedDispatch, useTypedSelector } from "../../redux/store";
import { sessionAction } from "../../redux/reducers/session";
import { languageAction } from "../../redux/reducers/language";

import { getLoginLanguage, storeLoginLanguage } from "./loginLanguage";

/**
 * Language of the login screens. `session.language` stays the single
 * source: after login the profile language wins as before, and without one
 * the interface opens in the language chosen here.
 */
export const useLoginLanguage = () => {
	const dispatch = useTypedDispatch();
	const language = useTypedSelector((state) => state.session.language);

	const setLanguage = useCallback(
		(lang: Language) => {
			storeLoginLanguage(lang);
			dispatch(sessionAction.setLanguage(lang));
			dispatch(languageAction.setLang(lang));
		},
		[dispatch],
	);

	return [language, setLanguage] as const;
};

/**
 * On the login screen take the stored choice, else the browser language,
 * else English. Layout effect: switched before the first paint.
 */
export const useInitLoginLanguage = (enabled: boolean) => {
	const dispatch = useTypedDispatch();
	const language = useTypedSelector((state) => state.session.language);

	useLayoutEffect(() => {
		if (!enabled) return;
		const lang = getLoginLanguage();
		if (lang === language) return;
		dispatch(sessionAction.setLanguage(lang));
		dispatch(languageAction.setLang(lang));
		// Once per login screen: later changes come from the picker.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, enabled]);
};
